module.exports = __webpack_public_path__ + "media/customizations/elevon/back-55516c20b5e799ef75d07f6f34d6564c.jpg";